import { forwardRef } from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "../lib/cn";

export interface SliderProps
  extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {}

/** Single-thumb slider: h-1.5 disabled track, primary range, 20px white thumb. */
export const Slider = forwardRef<
  React.ComponentRef<typeof SliderPrimitive.Root>,
  SliderProps
>(
  (
    {
      className,
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      "aria-valuetext": ariaValueText,
      ...props
    },
    ref,
  ) => {
    return (
      <SliderPrimitive.Root
        ref={ref}
        className={cn(
          "group relative flex w-full touch-none select-none items-center",
          className,
        )}
        {...props}
      >
        <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-surface-disabled">
          <SliderPrimitive.Range className="absolute h-full bg-surface-primary group-data-[disabled]:bg-border-strong" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledBy}
          aria-valuetext={ariaValueText}
          className={cn(
            // Thumb: 20px white (on-inverse is mode-locked) circle
            "block size-5 rounded-full border-2 border-surface-primary bg-on-inverse outline-none transition-colors duration-150",
            "group-data-[disabled]:border-border-strong group-data-[disabled]:bg-surface-raised",
            // Focus
            "focus-visible:ring-2 focus-visible:ring-border-focused focus-visible:ring-offset-1 focus-visible:ring-offset-surface-default",
            "disabled:cursor-not-allowed",
          )}
        />
      </SliderPrimitive.Root>
    );
  },
);
Slider.displayName = "Slider";
